// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wl_a bic_b"};